module.exports = __webpack_public_path__ + "static/media/0034.3586dcbb.png";